import {  internal, template, ReactiveElement, AttributeMarshallingMixin } from '../../vendor/elix.js';

class TpSingleSelectionList extends AttributeMarshallingMixin(ReactiveElement) {

  get selectionAttribute() {
    return this[internal.state].selectionAttribute;
  }

  set selectionAttribute(selectionAttribute) {
    this[internal.setState]({ selectionAttribute });
  }

  get selectedIndex() {
    return this.findChildIndex(c => !!c[this.selectionAttribute]);
  } 

  set selectedIndex(index) {
    this.selectChild(this.childrenAsArray[index]);
  }

  get selectedItem() {
    return this.findChild(c => !!c[this.selectionAttribute]);
  }

  set selectedItem(item) {
    this.selectChild(
      this.findChild(c => c === item)
    );
  }

  get value() {
    const selectedItem = this.selectedItem;
    if (selectedItem) {
      return selectedItem.value || selectedItem.textContent;
    } else {
      return undefined;
    }
  }

  set value(value) {
    this.selectChild(
      this.findChild(c => c.value === value || c.textContent === value)
    );
  }

  get childrenAsArray() {
    return Array.from(this.children);
  }

  selectChild(childToSelect) {
    this.childrenAsArray.forEach((child) => {
      child[this.selectionAttribute] = child === childToSelect;
    });
  }

  findChild(match) {
    return this.childrenAsArray.find(match);
  }

  findChildIndex(match) {
    const matchingChild = this.findChild(match);
    return matchingChild
      ? this.childrenAsArray.indexOf(matchingChild)
      : -1;
  }

  [internal.componentDidMount]() {
    super[internal.componentDidMount]();
    this.addEventListener('change', (e) => this.updateOnChildChange(e));
  }

  updateOnChildChange(e) {

    if (e.target === this) {
      return;
    }

    if (e.target[this.selectionAttribute]) {
      this.selectChild(e.target);
    } else {
      this.selectChild(undefined);
    }

  }

  get [internal.defaultState]() {
    return Object.assign(
      {},
      super[internal.defaultState],
      { selectionAttribute: 'selected' }
    );
  }

  get [internal.template]() {
    return template.html`<slot></slot>`;
  }
}

export default TpSingleSelectionList;
